define('constants/systemObjectIconNameConstants',[], function() {
    return {
        autoAttendant: 'autoAttendant',
        blocked: 'blockedContact',
        callQueue: 'callQueue',
        contact: 'contact',
        device: 'device',
        forwardingNumber: 'forwardingNumber',
        hangup: 'callFlowHangup',
        hostedNumber: 'phoneNumber',
        integration: 'integration',
        liveReceptionistScript: 'liveReceptionistScript',
        outboundCallingCampaign: 'outboundCallingCampaign',
        prompt: 'audioFile',
        ringing: 'callFlowRinging',
        schedule: 'schedule',
        scheduleSegment: 'scheduleSegment',
        subMenu: 'autoAttendantSubMenu',
        tresta: 'logoBadge',
        user: 'user',
        userGroup: 'group',
        voicemail: 'voicemail',
        voicemailBox: 'voicemailBox',
        webChatWidget: 'webChatWidget'
    };
});

